<template>
  <div>
    <div class="">
      <div class="row">
        <div class="col-12">
          <b-form-group v-model="hexSize" label="Hex Size" style="color:#333;">
            <b-form-radio-group v-model="hexSize">
              <b-form-radio value=16>16</b-form-radio>
              <b-form-radio value=32>32</b-form-radio>
              <b-form-radio value=48>48</b-form-radio>
              <b-form-radio value=64>64</b-form-radio>
              <b-form-radio value=128>128</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <h1 class="heading">Hexagon Component Test</h1>
          <HexagonGrid
            :hexData="hexData"
            :hexSize="parseInt(hexSize)"
            :enableClickSelect="true"
            @click="clickHandler($event)"
          />
        </div>
</div>
        <!-- <div class="col-5">
          <b-form-group label="Group By">
            <b-form-radio-group>
              <b-form-radio v-model="sortBy" name="some-radios" value="status">Status</b-form-radio>
              <b-form-radio v-model="sortBy" name="some-radios" value="assignedTo">Assignment</b-form-radio>
              <b-form-radio v-model="sortBy" name="some-radios" value="ticketType">Type</b-form-radio>
              <b-form-radio v-model="sortBy" name="some-radios" value="billable">Billable</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-5">
          <label style="font-size:1.2em; text-align:center;" for="range"> Scale Factor {{zoomValue}}</label>
          <input class="" id="range" type="range" min="5" max="30" @change="showVal()" step="5" v-model="zoomValue" />
        </div>
      </div>
      <div class="row">

      <div class="col-12">
        <h3>Grouping: {{sortBy}}</h3>
      </div>
        <div class="col-4 my-3" v-for="(ticketData,sectionIndex) in displayedTickets" :key="sectionIndex" >

          <div class="ticket-container">
              <hexagon class=" d-inline-block"
                :blockTitle="sectionIndex"
                :tickets="ticketData"
                :perRowHexa="12"
                hexWidth="400px"
              />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HexagonGrid from '@/components/HexagonGrid.vue'
export default {
  name: 'HexagonDashboard',
  components: {
    // Hexagon
    HexagonGrid
  },
  data() {
    return {
      // You can edit this data here:  https://app.json-generator.com/unR8sjbbQ4m-
      selectedElement: {},
        hexSize: 64,
        hexData: []  ,
        getHexDataURL: `https://api.json-generator.com/templates/unR8sjbbQ4m-/data`,
        // page: 1,
        // perPage: 5,
        // pages: [],
        // sortBy:'ticketType',
        // ticket: {},
        // zoomValue: 10,
        // tempTicketData:{},
        // tickets: require( '../../data/ticketData.json')
    }
  },
  mounted() {
    // token: bofgfk4x95tg3fmuoed31sg6du4ua5pwlvr3jbfh
    fetch(this.getHexDataURL,{
      method: "GET",
      headers: {
        Authorization: 'Bearer bofgfk4x95tg3fmuoed31sg6du4ua5pwlvr3jbfh',
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      }
    })
      .then(response => {
        return response.json();
      })
      .then(res => {
        this.hexData = res;
      })
      .catch(error => console.log("error", error));
  },
  created() {
      // this.setPages();
  },
  computed: {
   displayedTickets () {
      let sortedData = [];
      let tempTicketData = {};

      this.tickets.map(ticket=>{
          //this.tempTicketData[ticket.category]
          if(tempTicketData[ticket[this.sortBy]]){
              tempTicketData[ticket[this.sortBy].toString()].push(ticket)
          }else{
              tempTicketData[ticket[this.sortBy].toString()]=[ticket]
          }
      });

      // Object.keys(tempTicketData).map(function(key, index) {
      //   tempTicketData[key].map((ticket) => {
      //     sortedData.push(ticket);
      //   })
      // });
      // console.log('data', tempTicketData)
      // return sortedData;
      return tempTicketData;
    }
  },
  watch: {
    tickets () {
        this.setPages(); // it will call if value get from url/dynamically
    }
  },
  methods: {
    setPages () {
        let numberOfPages = Math.ceil(this.tickets.length / this.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
            this.pages.push(index);
        }
    },
    paginate (tickets) {
        let page = this.page;
        let perPage = this.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);
        // console.log("debugger")
        return  tickets.slice(from, to);
    },
    setZoom(zoom,el) {

      let transformOrigin = [0,0];
	    el = el || instance.getContainer();
	    var p = ["webkit", "moz", "ms", "o"],
            s = "scale(" + zoom + ")",
            oString = (transformOrigin[0] * 100) + "% " + (transformOrigin[1] * 100) + "%";

	    for (var i = 0; i < p.length; i++) {
	        el.style[p[i] + "Transform"] = s;
	        el.style[p[i] + "TransformOrigin"] = oString;
	    }

	    el.style["transform"] = s;
	    el.style["transformOrigin"] = oString;

    },
    showVal(){
        // console.log(this.zoomValue)
        var zoomScale = Number(this.zoomValue)/10;
        this.setZoom(zoomScale,document.getElementsByClassName('ticket-container')[0])
    }
  }
}
</script>
<style lang="scss" >


  .ticket-container {
    margin:1em;
    padding: .25em;
    // border-radius:.5em;
    // padding-right:50%;

  }

  .show-hand {
    cursor:pointer;
  }

$track-w: 12.5em;
$track-h: .15em;
$thumb-d: .8em;

@mixin track() {
    box-sizing: border-box;
    border: none;
    width: $track-w; height: $track-h;
    background: #ccc;
}

@mixin thumb() {
    box-sizing: border-box;
    border: none;
    width: $thumb-d; height: $thumb-d;
    border-radius: 50%;
    background: #f90;
}

.sidebar {
    float: left;
    position: relative;
    margin: 0 .5em .5em;
    padding: .5em;
    height: $track-w; width: $thumb-d;
}

[type='range'] {
    &, &::-webkit-slider-thumb {
        -webkit-appearance: none;
    }
    &:hover, &:focus, &:active{
        outline: none;
    }
    position: absolute;
    top: 50%; left: 50%;
    margin: 0;
    padding: 0;
    width: $track-w; height: $thumb-d;
    //transform: translate(-50%, -50%) rotate(-90deg);
    background: transparent;
    font: 1em/1 arial, sans-serif;

    &::-webkit-slider-runnable-track {
        @include track
    }
    &::-moz-range-track { @include track }
    &::-ms-track { @include track }

    &::-webkit-slider-thumb {
        margin-top: .5*($track-h - $thumb-d);
        @include thumb
    }
    &::-moz-range-thumb { @include thumb }
    &::-ms-thumb {
        margin-top: 0;
        @include thumb
    }

    &::-ms-tooltip { display: none }
}


</style>
